import PropTypes from 'prop-types';
import React from 'react';

var GlobalCountriesSelector = function GlobalCountriesSelector(_ref) {
  var onTerritorySelect = _ref.onTerritorySelect,
      formatMessage = _ref.formatMessage,
      messages = _ref.messages;

  /**
   * @description Dispatch action creator with param selectAll
   * @param listType {string}
   * @param territoryId {number}
   * @param selectAll {bool}
   */
  var handleSelectAll = function handleSelectAll() {
    return onTerritorySelect(null, true);
  };
  /**
   * @description Dispatch action creator with param select none
   * @param listType {string}
   * @param territoryId {number}
   * @param selectAll {bool}
   * @param selectNone {bool}
   */


  var handleSelectNone = function handleSelectNone() {
    return onTerritorySelect(null, null, true);
  };

  return React.createElement("div", {
    className: "GlobalCountriesSelector"
  }, React.createElement("b", null, "Select:"), React.createElement("span", {
    className: "GlobalCountriesSelector-all btn-link",
    onClick: handleSelectAll
  }, React.createElement("b", null, formatMessage(messages.selectAllLabel))), React.createElement("span", {
    className: "GlobalCountriesSelector-none btn-link",
    onClick: handleSelectNone
  }, React.createElement("b", null, formatMessage(messages.selectNoneLabel))));
};

GlobalCountriesSelector.propTypes = {
  onTerritorySelect: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.object.isRequired
};
export default GlobalCountriesSelector;